
import { BasePage } from "./BasePage";

import type { PageTemplateProps } from "./types";

// Supplier Assortment Assessment. Per the Digital Data Room spec this is
// a tiered audit (Full 12-slide / Standard 8-slide / Quick Scan 1-page).
// v0.5 renders whatever widgets the SEM attaches in the JSON — typically
// a leading RichText framing + a gdoc_embed or pdf_embed of the live audit.
export function SupplierAssortmentAssessment(props: PageTemplateProps) {
    return <BasePage {...props} />;
}
